// extracted by mini-css-extract-plugin
export var label = "_dm-2";
export var slideContainer = "_dm-0";
export var slider = "_dm-1";